<template>
    <div v-observe-visibility="visibilityChanged">

        <!--DELETE - Dialog-->
        <v-dialog
                persistent
                v-model="deleteDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Delete Position</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" v-model="deleteFormValidation" lazy-validation>
                        <v-checkbox
                                :rules="[v => !!v || 'You have to check this to continue!']"
                                required
                                v-model="deleteChecked" color="primary"
                                label="Do you really want to delete this position?"></v-checkbox>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog()">CANCEL</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="deleteInquiryPosition(editInquiryPositionData)">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-layout row wrap>

            <v-flex xs12 sm12 pr-4 pt-4 pl-4>

                <v-btn class="secondary white--text" @click.native="openAddSupplierOfferDialog()">
                    New Supplier Offer
                    <v-icon class="white--text" right>add</v-icon>
                </v-btn>

            </v-flex>

        </v-layout>

        <v-layout id="table-container" row>
            <v-flex xs12 pr-4 pt-4 pl-4>
                <v-card>
                    <v-card-title>
                        Supplier Offer Positions
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-card-title>

                    <v-data-table
                            :headers="headers"
                            :items="getItems"
                            :pagination.sync="pagination"
                            :total-items=total
                            class="elevation-0 offer-table"
                            :loading="loadingOffers"
                            :rows-per-page-items="rowsPageItems"
                    >

                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                <span>
                                          {{ props.header.text }}
                                        </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td>{{ props.item.suppliers_offer.id }}</td>
                                <td class="text-xs-left">{{ props.item.suppliers_offer.supplier.name}}</td>
                                <td class="text-xs-left">{{ props.item.suppliers_offer.offer_number}}</td>
                                <td class="text-xs-left">{{formatToMoney(props.item.unit_price) }} {{props.item.suppliers_offer.currency.name }}</td>
                                <td class="text-xs-left">{{props.item.delivery_time.value}} {{props.item.delivery_time.delivery_times_type.name}}</td>
                                <td class="text-xs-left">{{ props.item.suppliers_offer.valid_until | toDateOnly }}</td>

                            </tr>
                        </template>
                    </v-data-table>

                </v-card>
            </v-flex>
        </v-layout>

        <AddSupplierOfferDialog></AddSupplierOfferDialog>

    </div>
</template>

<script>
    import {
        Settings,
        Offer,
        OfferPosition,
        ManufacturersSettings,
        ProductSettings,
        VatSettings,
        SupplierOfferPositions,
        SupplierOffers
    } from '../../../../store/namespace-helper'

    import AddSupplierOfferDialog from '../../../SupplierOffers/AddSupplierOfferDialog.vue'

    import {dateFunctionFilters} from '../../../../mixins/dateFunctionFilters'

    import _ from 'lodash'

    export default {
      name: 'SupplierOffers',
      mixins: [dateFunctionFilters],
      components: {
        AddSupplierOfferDialog
      },
      data () {
        return {
          isVisible: false,
          hide: true,
          activeTab: 0,
          headers: [
                    {text: 'Offer-ID', value: 'id'},
                    {text: 'Supplier', value: 'suppliers_offer.supplier.name', sortable: false},
                    {text: 'Offer Number', value: 'offer_number'},
                    {text: 'Unit Price', value: 'unit_price'},
                    {text: 'Delivery', value: 'delivery_times', sortable: false},
                    {text: 'Valid Until', value: 'valid_until'}

          ],
          pagination: {},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [10, 25, 50, 100, 250],
          selectedSuppliers: null,
          chipsDeletable: true,
          addDialog: false,
          deleteDialog: false,
          deleteChecked: false,
          deleteFormValidation: false,
          rules: {
            required: value => !!value || 'Required.',
            descriptionCounter: value => value.length <= 500 || 'Max 500 characters',
            numberCounter: value => value.length <= 255 || 'Max 255 characters'
          },
          creatingRequestsErrorMsg: '',
          squareFlag: false,
          creatingOffer: false,
          loadingOffers: false
        }
      },
      mounted () {

      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadItems()
            } else {

            }
          }
        },
        loadItems: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            id: this.getSelectedProduct.id,
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          this.loadingOffers = true
          this.$store.dispatch(SupplierOfferPositions.actions.loadSupplierOfferPositionByProductIDIndex, query).then(response => {
            this.loadingOffers = false
          }).catch(err => {
            this.loadingOffers = false
            console.log(JSON.stringify(err))
          })
        },
        loadManufacturers () {
          this.$store.dispatch(ManufacturersSettings.actions.loadAllManufacturers)
        },
        loadUnits () {
          this.$store.dispatch(Settings.actions.loadAllUnits)
        },
        loadSuppliers (manufacturersId) {
          console.log('loading all suppliers for manufacturers_id: ' + manufacturersId)
          this.$store.dispatch(Settings.actions.loadSuppliersByManufacturers, manufacturersId)
        },
        loadProducts () {
          this.$store.dispatch(ProductSettings.actions.loadAllProducts)
        },
        loadVats () {
          this.$store.dispatch(VatSettings.actions.loadAllVats)
        },
/*        openSupplierOfferDialog (val) {
          let item = this.getItems.find(x => x.id === val)
          if (item !== null && typeof item !== 'undefined') {
            this.$store.dispatch(OfferPosition.actions.setSelectedOfferPosition, item)
          }
          this.addDialog = true
        }, */
        openAddSupplierOfferDialog () {
          this.$store.dispatch(SupplierOffers.actions.setSelectedSupplierOffer, null)
          this.$store.dispatch(SupplierOffers.actions.openCloseDialog)
        },
        getManufacturerName (val) {
          let item = this.getProducts.find(x => x.id === val)
          if (item !== null && typeof item !== 'undefined') {
            if (item.manufacturer !== null && typeof item.manufacturer !== 'undefined') {
              return item.manufacturer.name
            }
          }
          return ''
        },
        savePosition () {
          console.log('saveNewOfferPosition: ' + JSON.stringify(this.getSelectedOfferPosition))
          console.log('getSelectedOffer: ' + JSON.stringify(this.getSelectedOffer))

          this.getSelectedOfferPosition.customers_offers_id = this.getSelectedOffer.id

          this.$store.dispatch(OfferPosition.actions.saveOfferPosition, this.getSelectedOfferPosition)

          this.addDialog = false
        },
        createCustomerOffer () {
          this.$store.dispatch(Offer.actions.createCustomerOfferMessage, this.getSelectedOffer.id).then(response => {
            this.creatingOffer = true
            this.$echo.private('customer-offer-created-chan.' + this.getSelectedOffer.id).listen('CustomerOfferCreated', (payload) => {
              console.log('message sent event: ' + JSON.stringify(payload))
              this.$store.dispatch(Offer.actions.reloadSelectedCustomerOffer, this.getSelectedOffer.id).then(response => {
                this.$echo.leave('customer-offer-created-chan.' + this.getSelectedOffer.id)
              })
              this.creatingOffer = false
            })
          })
        },
        deleteInquiryPosition (item) {
          if (!this.$refs.form.validate()) {
            return
          }

          this.deleteDialog = false
          this.deleteChecked = false

                /*          const {sortBy, descending, page, rowsPerPage} = this.pagination */
                /*          const requestData = {
                            id: this.getSelectedInquiry.id,
                            sortBy: sortBy || 'id',
                            descending: descending ? 'desc' : 'asc',
                            page: page || 1,
                            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
                            search: this.search ? this.search : '',
                            inquiryPosition: item
                          } */

                /*          this.$store.dispatch(OfferPosition.actions.deleteInquiriesPositions, requestData) */
        },
        deletePositionDialog (item) {
          this.editInquiryPositionData = _.cloneDeep(item)
          this.deleteDialog = true
        },
        cancelDeleteDialog () {
          this.deleteDialog = false
          this.$refs.form.reset()
        },
        openCalculateDialog (val) {
          let item = this.getItems.find(x => x.id === val)
          if (item !== null && typeof item !== 'undefined') {
            this.$store.dispatch(OfferPosition.actions.setSelectedOfferPosition, item)
          }
          this.$store.dispatch(OfferPosition.actions.openCloseCalculateDialog)
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450),
        throttledTranslate: _.debounce(function (q, target) {
          this.translate(q, target)
        }, 450),
        formatToMoney (val) {
          return new Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2

          }).format(val)
        }

      },
      computed: {
        getItems () {
          console.log(this.$store.getters[SupplierOfferPositions.getters.getSupplierOfferPositions].data)
          this.total = this.$store.getters[SupplierOfferPositions.getters.getSupplierOfferPositions].total
          return this.$store.getters[SupplierOfferPositions.getters.getSupplierOfferPositions].data
        },
        getSuppliers () {
          return this.$store.getters[Settings.getters.getManufacturerSuppliers]
        },
        getSelectedProduct () {
          return this.$store.getters[ProductSettings.getters.getSelectedProduct]
        },
        getCreatingOfferForInquiry () {
          return this.$store.getters[Offer.getters.getCreatingOfferForInquiry]
        },
        getSelectedOfferPosition () {
          return this.$store.getters[OfferPosition.getters.getSelectedOfferPosition]
        },
        getManufacturers () {
          return this.$store.getters[ManufacturersSettings.getters.getAllManufacturers]
        },
        getProducts () {
          return this.$store.getters[ProductSettings.getters.getAllProducts]
        },
        getVats () {
          return this.$store.getters[VatSettings.getters.getAllVats]
        },
        getUnits () {
          return this.$store.getters[Settings.getters.getAllUnits]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        descriptionRules () {
          return [this.rules.descriptionCounter]
        },
        numberRules () {
          return [this.rules.numberCounter]
        },
        calculateDialogState () {
          return this.$store.getters[OfferPosition.getters.getOpenCalculateDialogState]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        calculateDialogState: {
          handler (val) {
            if (!val) {
              this.loadItems()
            }
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        }
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }


</style>



// WEBPACK FOOTER //
// src/components/Settings/Products/SupplierOffers/SupplierOffers.vue